export default __webpack_public_path__ + "static/media/cert3.aa730b50.jpg";